/* eslint-disable react/no-danger */
/* eslint-disable jsx-a11y/alt-text */
import { Button } from 'antd';
import React, { useState } from 'react';

import { FaRegFileAudio, FaRegFileVideo, FaRegFileExcel } from 'react-icons/fa';
// import Btn from '../../../../components/Btn/Btn';
import Answers from './components/Answers/Answers';
import './style.module.scss';

function Question({ question, sendAnswer, formatMessage, isAnswer, onSetIsLoaded, onSetIsAnswer, clearAnswer, help }) {
  const [value, setValue] = useState('');

  if (!question) {
    return null;
  }

  const onSendAnswer = () => {
    if(isAnswer){
      setValue('');
      onSetIsAnswer(false);
      onSetIsLoaded(false);
      setTimeout(() => {
        onSetIsLoaded(true);
      }, 100);
    } else {
      sendAnswer(value);
    }
  }

  return (
    <div className={'QuestionMylty'}>
      <div
        className={'title_text'}
        dangerouslySetInnerHTML={{
          __html: question.question,
        }}
      />
      <Answers
        question={question}
        help={help}
        onChange={(v) => {
          onSetIsAnswer(false)
          setValue(v);
        }}
        value={value}
        onSendAnswer={onSendAnswer}
        isAnswer={isAnswer}
      />
      <div className={'actions'}>
        <Button
          type={isAnswer ? 'default' : 'primary'}
          className="ant-btn-primary-circle"
          disabled={!value}
          onClick={() => {
            if(isAnswer){
              setValue('');
              onSetIsAnswer(false);
              onSetIsLoaded(false);
              clearAnswer()
              setTimeout(() => {
                onSetIsLoaded(true);
              }, 100);
            } else {
              sendAnswer(value);
            }
          }}
        >
          {isAnswer ? formatMessage('resetAnswer') : formatMessage('sendAnswer')}
        </Button>
      </div>
    </div>
  );
}

export default Question;



// WEBPACK FOOTER //
// ./yii2/frontend/frontend-assets/src/components/QuestionMultyView/components/Question/Question.jsx